import { createLocalizationService } from "../../services/createLocalizationService";
import { REWAMP_LOCALE_NAMESPACE } from "./constants";

// Own cache-key prefix so its localStorage entries never collide with the legacy Locale.* ones.
export const RewampLocalizationService = createLocalizationService({
  namespace: REWAMP_LOCALE_NAMESPACE,
  cachePrefix: "RewampLocale",
  // No dfsweb-rewamp-* module exists on the CMS yet — don't cache their emptiness for 24h.
  cacheEmptyModules: false,
});
